import React, { useState } from 'react';
import { useAuth, pagesForRole } from './context/AuthContext';
import { ToastProvider } from './components/Toast';
import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import Agenda from './pages/Agenda';
import Clientes from './pages/Clientes';
import Notas from './pages/Notas';
import Usuarios from './pages/Usuarios';
import Reportes from './pages/Reportes';
import Ajustes from './pages/Ajustes';
import Inventario from './pages/Inventario';
import { LOGO_FOOTER, LOGO_TOPBAR } from './logos';

const PAGES = {
  agenda: Agenda,
  clientes: Clientes,
  inventario: Inventario,
  notas: Notas,
  usuarios: Usuarios,
  reportes: Reportes,
  ajustes: Ajustes
};

export default function App() {
  const { user, logout, clinicName, clinicLogo } = useAuth();
  const [page, setPage] = useState('agenda');

  if (!user) {
    return (
      <ToastProvider>
        <Login />
      </ToastProvider>
    );
  }

  const allowed = pagesForRole(user.rol);
  const current = allowed.includes(page) ? page : allowed[0];
  const Page = PAGES[current];

  return (
    <ToastProvider>
      {/* Topbar */}
      <header style={{
        position: 'fixed', top: 0, left: 0, right: 0, height: 56,
        background: '#185fa5', display: 'flex', alignItems: 'center',
        padding: '0 16px', gap: 12, zIndex: 200
      }}>
        {/* Esquina superior izquierda. Sin logo propio se muestra la marca por
            defecto: antes quedaba vacio hasta que alguien subiera uno en Ajustes. */}
        <img
          src={clinicLogo || LOGO_TOPBAR}
          alt=""
          style={{ height: 34, width: 34, objectFit: 'cover', borderRadius: 8, flexShrink: 0 }}
        />
        <div style={{ color: '#fff', fontWeight: 800, fontSize: 16, letterSpacing: 0.2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {clinicName}
        </div>
        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 12 }}>
          <div className="hide-mobile" style={{ color: '#dbeafe', fontSize: 13, fontWeight: 600 }}>
            {user.nombre} · {user.rol}
          </div>
          <button
            onClick={logout}
            style={{
              background: 'rgba(255,255,255,0.14)', color: '#fff', border: 'none',
              borderRadius: 8, padding: '7px 13px', fontWeight: 700, fontSize: 13
            }}>
            Salir
          </button>
        </div>
      </header>

      <Sidebar page={current} setPage={setPage} />

      {/* Contenido */}
      <main className="app-content" style={{
        marginLeft: 210, marginTop: 56, marginBottom: 44,
        padding: 22, minHeight: 'calc(100vh - 100px)'
      }}>
        <Page />
      </main>

      {/* Footer fijo */}
      <footer style={{
        position: 'fixed', left: 0, right: 0, bottom: 0, height: 44,
        background: '#185fa5', display: 'flex', alignItems: 'center',
        justifyContent: 'center', zIndex: 200
      }}>
        <img src={LOGO_FOOTER} alt="Acrox Assistant" style={{ height: 23 }} />
      </footer>
    </ToastProvider>
  );
}
